import { inject, Injectable } from "@angular/core";
import { TrpcService } from "../trpc/trpc.service";
import { TableLazyLoadEvent } from "primeng/table";
import { GetSequenceNumbersRequest, GetSequencesRequest, MPISequenceDto } from "../../../../../express-tRPC/src/api/sequences/types";

@Injectable({
    providedIn: 'root'
})
export class SequenceService {
    private trpc = inject(TrpcService);

    constructor() { }

    getSequences(event: TableLazyLoadEvent, showAllSequences: boolean) {
        const sortOrder = event.sortOrder ? (event.sortOrder > 0 ? 'ASC' : 'DESC') : 'ASC';
        const sortField: string = event.sortField ? (typeof event.sortField === 'string' ? event.sortField : event.sortField[0]) : 'cust_location';
        const filter: GetSequencesRequest = {
            skip: event.first ? event.first : 0,
            limit: event.rows ? event.rows : 10,
            order: {
                field: sortField,
                sortOrder: sortOrder
            },
            showAllSequences: showAllSequences
        }
        console.log('getSequences filter: ', filter);
        return this.trpc.trpc.sequence.getSequences.query(filter);
    }

    getSequencesCount(event: TableLazyLoadEvent, showAllSequences: boolean) {
        const sortOrder = event.sortOrder ? (event.sortOrder > 0 ? 'ASC' : 'DESC') : 'ASC';
        const sortField: string = event.sortField ? (typeof event.sortField === 'string' ? event.sortField : event.sortField[0]) : 'cust_location';
        const filter: GetSequencesRequest = {
            skip: event.first ? event.first : 0,
            limit: event.rows ? event.rows : 10,
            order: {
                field: sortField,
                sortOrder: sortOrder
            },
            showAllSequences: showAllSequences
        }
        console.log('getSequences filter: ', filter);
        return this.trpc.trpc.sequence.getSequencesCount.query(filter);
    }

    getSequenceNumbersForSequenceID(location: string, seqid: string, skip = 0, limit = 10, showAllSequences: boolean, sortField: string = 'seqnum', sortOrder: 'ASC' | 'DESC' = 'ASC'): Promise<{ result: MPISequenceDto[], count: number }> {
        const filter: GetSequenceNumbersRequest = {
            location: location,
            seqid: seqid,
            skip: skip,
            limit: limit,
            order: {
                field: sortField,
                sortOrder: sortOrder
            },
            showAllSequences: showAllSequences
        };

        return this.trpc.trpc.sequence.getSequenceNumbersForSequenceID.query(filter);
    }

    updateSequencesStatus(rowIDs: MPISequenceDto[], status: string): Promise<boolean> {
        return this.trpc.trpc.sequence.updateSequencesStatus.mutate({sequences: rowIDs, status: status});
    }
}